import * as React from 'react';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import { useState, useEffect } from 'react';
import { Divider, CircularProgress } from '@mui/material';
import FormPlans from './FormPlans';
import './styles.css'; // Import the CSS file
import axios from './../../axios/api';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '50%',
    maxHeight: '85vh', // Set max height for modal content
    bgcolor: 'background.paper',
    border: '0.2px solid #eee',
    borderRadius: 5,
    boxShadow: 24,
    p: 4,
    overflowY: 'auto', // Enable vertical scrolling for the content
};

const EditPlansModal = ({ open, handleCloseModal, id, refreshData }) => {
    console.log("open Status" + open);
    const [openModal, setOpenModal] = useState(open);
    const [isLoading, setIsLoading] = useState(false);
    const [Data, setData] = useState([]);

    const handleClose = () => {
        setOpenModal(false);
        handleCloseModal();
    };

    useEffect(() => {
        setOpenModal(open);
    }, [open]);


    useEffect(() => {
        setData([]);
        getDataSelected();
    }, [id])

    const getDataSelected = async () => {
        try {
            setIsLoading(true);
            let url = `/admin/plan/show/${id}`;
            const res = await axios.get(url);
            setData(res.data?.data);
        } catch (e) {
            console.log(e.response, "eeeeeeeee");
        } finally {
            setIsLoading(false);
        }
    };


    return (
        <Modal
            open={openModal}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
        >
            <Box sx={style} className="hide-scrollbar">

                {isLoading ?
                    <Box mt={2} display="flex" flexDirection="row" alignItems="center" justifyContent="center" >
                        <CircularProgress size={24} color="inherit" />
                    </Box>
                    :
                    <>
                        <Typography variant='h4' textAlign="center">ویرایش اطلاعات پلن</Typography>
                        <Divider sx={{ my: 2 }} />
                        <FormPlans
                            IdEdit={id}
                            isEdit
                            DataEdit={Data}
                            refreshData={refreshData}
                            handleCloseModal={handleCloseModal}
                        />
                    </>
                }
            </Box>
        </Modal>
    );
}

export default EditPlansModal;
